<app-toaster></app-toaster>

<main>
	<router-outlet></router-outlet>
</main>
